import type { NoddiIconName } from 'noddi-ui-common';
import { NavioOverlayActions, NoddiButton } from 'noddi-ui-web';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  /**
   * The step's own primary button, so it stays inside that step's form context. The row renders in
   * the dialog footer, outside the step's `<form>`, so a submit button needs `formId`.
   */
  action: ReactNode;
  /** Back on every step after the first, which offers Cancel instead so the footer keeps its shape. */
  secondary: { label: string; onClick: () => void; icon?: NoddiIconName };
};

/**
 * The frame every add-member step shares: the dialog sizes to its step between a floor and a
 * viewport cap, so short steps do not collapse and only a tall one scrolls its body.
 */
export const AddMemberStepLayout = ({ children, action, secondary }: Props) => (
  <>
    <div className='minimal-scrollbar-hover flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto'>{children}</div>
    <NavioOverlayActions>
      <NoddiButton
        type='button'
        variant='outline'
        startIcon={secondary.icon}
        className='flex-1'
        onClick={secondary.onClick}
      >
        {secondary.label}
      </NoddiButton>
      {action}
    </NavioOverlayActions>
  </>
);
